var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":"analyzer","height":"auto","width":"700px","styles":"border-radius: 10px 10px 10px 10px"},on:{"before-open":_vm.beforeOpen}},[_c('smart-analyser',{ref:"smartanal",attrs:{"value":_vm.value,"source":_vm.source,"fromGraph":_vm.fromGraph},on:{"runSelectedTool":function($event){return _vm.handleSelectedAnalyse($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }